import ReportComplexity from "../commons/model/report/ReportComplexity";
import * as React from "react";
import reportComplexityBar from "../commons/components/ReportComplexityBar";
import FlowType from "../commons/model/FlowType";

namespace ReportComplexityUtils {
  export const getReportComplexityI18nKey = function (type: ReportComplexity) {
    switch (type) {
      case ReportComplexity.EASY:
        return "Global.Reports.Complexity.Easy";
      case ReportComplexity.STANDARD:
        return "Global.Reports.Complexity.Standard";
      case ReportComplexity.COMPLEX:
        return "Global.Reports.Complexity.Complex";
    }
  };

  export const getRenderForLeadList = function (complexity: ReportComplexity, flowtype?: FlowType) {
    return (
      <>
        {!!complexity &&
          flowtype != null &&
          flowtype != FlowType.SMILE_SIMULATION &&
          reportComplexityBar(complexity)}
        {(!complexity || flowtype == null || flowtype == FlowType.SMILE_SIMULATION) && (
          <div className="flex-center justify-center">
            <div className="no-score"></div>
          </div>
        )}
      </>
    );
  };
}

export default ReportComplexityUtils;
